<template>
  <div>
    <div class="b-banner-con">
      <v-header></v-header>
      <v-nav></v-nav>
    </div>
    <v-breadcrumb></v-breadcrumb>
    <!-- 主题内容 -->
    <div class="b-center-container">
      <!-- 富文本 -->
      <div class="b-container">
        <div class="b-center-main">
          <div class="b-richtext">
            <p v-html="richText"></p>
          </div>
        </div>
      </div>
    </div>
    <v-contact></v-contact>
      <!--
      <v-footer></v-footer>
      <v-copy></v-copy>
      -->
  </div>
</template>
<script>
/* eslint-disable */
import Header from "@/components/header/en/";
import Nav from "@/components/nav/en/";
import Copy from "@/components/copy/"
import Breadcrumb from "@/components/breadcrumb/en/"
import Footer from "@/components/footer/"
import Contact from "@/components/contact/en/";
export default {
  data () {
    return {
      richText: '',
    };
  },
  mounted () {
    this.richText = '<p style="text-align: left; "><span style="font-size: 22px; border-bottom: solid 3px #033d80;">Center for Biomedical Data Science</span></p>'
      //+ '<div style="margin-left : 40px; margin-bottom: 20px"><div style="font-size: 20px;"><b style="color: #033d80; "> | </b> 简介</span></p>'
      + '<p>&nbsp;</p>'

      + '<div id="left" style="float:left ; width:70%; height:100%;">'
      + '<p style="margin-bottom : 20px; margin-right : 50px;text-align: justify"><span style="font-size: 16px">Center for Biomedical Data Science provides statistical analysis, medical information management and bioinformatics research services, which is supported by the excellent research experts of the SJTU-Yale Joint Center for Biostatistics and Data Science. The statistical analysis module contains a series of services to support the publication of scientific research papers, including clinical trial study design and real-world data analysis. These services strictly follow international standards, such as International Council for Harmonization of Technical Require- ments for Pharmaceuticals for Human Use (ICH). Medical information management relies on the powerful Cloud Computing Service (JCloud) and the Artificial Intelligence Server (DGX) of Shang- hai Jiao Tong University to provide services, such as clinical data collection and management, electronic patient profile data mining and medical image analysis. Bioinformatics research involves various types of omics information analysis including computational system biology analysis of complex diseases, proteomics analysis and metagenomics analysis.</sspan></p>'
      + '<p style="margin-bottom : 20px; margin-right : 50px;text-align: justify"><span style="font-size: 16px">Our research center has established standardized processes offering clinical trial data analysis, safety data analysis and consistency evaluation of diagnostic reagents. To provide sufficient conditions for high-quality clinical research, data collection EDC systems, randomiza- tion systems, sample size calculators and Rshiny data visualization tools are comprehensively developed. Besides, analysts working in our center have been experienced in applying artificial intelligence algorithms to analyze medical images and constructing prediction models of medi- cal big data.</span></p>'
      // + '<p style="text-align: left; margin-left : 180px"><span style="font-size: 18px; ">联系人</span></p>'
      // + '<p style="text-align: left; margin-left : 180px"><span style="font-size: 16px; color: #033d80; ">姓名：崔祎赟</span></p>'
      // + '<p style="text-align: left; margin-left : 180px"><span style="font-size: 16px; ">邮箱：cyysjtu@sjtu.edu.cn</span></p>'
      // + '<p style="text-align: left; margin-left : 180px"><span style="font-size: 16px; ">电话：17740823635</span></p>'
      + '</div>'


      + '<div id="right" style="float:left ; width:30%; height:100%;">'
      + '<p style="margin-left : 50px"><img src="https://nbcloud-repairorder-image.oss-cn-beijing.aliyuncs.com/yuzhangsheng.jpg" style="float: center; width: 200px;  margin-right: 40px;"  border="0" vspace="0" alt=""></p>'
      + '<p style="margin-bottom : 20px;text-align: justify"><span style="font-size: 10px;"><b>Director: Zhangsheng Yu</b><br>' +
      'Professor, Shanghai Jiao Tong University Associate Director, SJTU-Yale Joint Center for Biostatistics and Data Science\n' +
      'Experienced as an editor-in-chief or an editorial board member of many international SCI journals of medicine and statistics.\n' +
      'Experienced in publishing medical papers with high influential factors on JAMA, Lancet and etc.</span></p>'
      + '</div>'
      + '<p style="margin-left : 20px"><img src="https://nbcloud-repairorder-image.oss-cn-beijing.aliyuncs.com/biomedical_data_science_en.jpg" style="float: left; width: 1200px;  margin-right: 20px;" border="0" vspace="0" alt=""></p>'

      + '<p>&nbsp;</p><p>&nbsp;</p>'
      + '<p style="text-align: left; "><span style="font-size: 16px; border-bottom: solid 3px #033d80;">Contact</span></p>'
      + '<p style="text-align: left; "><span style="font-size: 16px; ">Jiali Jiao</span></p>'
      + '<p style="text-align: left; "><span style="font-size: 16px; ">Email: katherinejiao@sjtu.edu.cn</span></p>'
      + '<p>&nbsp;</p>'
},
  components: {
    "v-header": Header,
    "v-nav": Nav,
    "v-copy": Copy,
    "v-breadcrumb": Breadcrumb,
    "v-footer": Footer,
    "v-contact": Contact,
  }
};
</script>
<style lang="scss">
  @media screen and (max-width:600px) {
	.b-banner-con{
	    //padding: 22px 0;
	    background: url(../../../assets/img/banner_bg.png) no-repeat!important;
	    background-size: cover!important;
	    .b-header{
	      margin-bottom: 0px;
	    }
	    height: 134px;
	    width: 1440px;
	}
  }

  @media screen and (min-width:960px) {
    .b-banner-con{
	    //padding: 22px 0;
	    background: url(../../../assets/img/banner_bg.png) no-repeat!important;
	    background-size: cover!important;
	    .b-header{
	      margin-bottom: 0px;
	    }
	    height: 134px;
    }
  }
.b-richtext {
  text-align:left;
  b,
  strong {
    font-weight: 700;
  }
  p {
    margin: 0 0 10px;
    line-height: 24px;
  }
  line-height: 24px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Service2/en/index.vue